import { ClientResult } from '@vp/client-result';
import { AuthTokenHeader, FetchClient } from '@vp/fetch-client';

import { ICombination } from '../../types/interfaces';
import { configuration } from '../serverConfigurationProvider';

export async function getAllViews(
  tenant: string,
  productKey: string,
  productVersion: number,
  combination: ICombination,
  fetchClient: FetchClient,
  tokenConfig: AuthTokenHeader
): Promise<ClientResult<LookupPreviewResponse>> {
  const optionSelectionsUri = encodeObject(combination);
  const tenantUri = encodeObject({ id: `${tenant}-prod`, type: 'merchants' });
  const url = `${configuration.serviceUrls.lookupPreview}api/v2/views?tenant=${tenantUri}&referenceId=${productKey}&referenceVersion=${productVersion}&attributes=${optionSelectionsUri}`;

  const lookupPreviewClientResponse = await fetchClient.authenticatedGet<LookupPreviewResponse>(
    url,
    tokenConfig
  );
  return lookupPreviewClientResponse;
}

function encodeObject(combination: Record<string, string>): string {
  return encodeURIComponent(JSON.stringify(combination));
}

export interface LookupPreviewResponse {
  views: View[];
}
export interface View {
  name?: string;
  purpose: string;
  subPurpose?: string;
}
